import zIndexes from "zIndexes.module.scss";

export const getBorderColor = (level: string) => {
  switch (level) {
    case "success":
      return "1px solid #4caf50";
    case "error":
      return "1px solid #e84046";
    case "warning":
      return "1px solid #e2b33b";
    default:
      return "1px solid #a6e9f2";
  }
};

export const getLevelBackgroundColor = (level: string) => {
  switch (level) {
    case "success":
      return "#b5dfb7";
    case "error":
      return "#f8c8ca";
    case "warning":
      return "#f6ecc1";
    default:
      return "#e5f8fb";
  }
};

export const getPosition = (position?: string) => {
  switch (position) {
    case "tl":
      return {
        alignSelf: "flex-start",
      };
    case "tc":
      return {
        alignSelf: "center",
      };
    case "tr":
    default:
      return {
        alignSelf: "flex-end",
      };
  }
};

export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "10px",
  },
  errorIcon: {
    strokeWidth: "2.5px",
    stroke: "#e84046",
    fill: "transparent",
    width: "21px",
    height: "21px",
  },
  warningIcon: {
    fill: "transparent",
    stroke: "#e2b33b",
    width: "21px",
    height: "21px",
  },
  infoIcon: {
    fill: "var(--EventsBluePrimary)",
    width: "21px",
    height: "21px",
  },
  successIcon: {
    strokeWidth: "3.5px",
    stroke: "#4caf50",
    width: "21px",
    height: "21px",
  },
  notificationItem: {
    zIndex: zIndexes.notificationsZIndex,
    maxWidth: "364px",
    backgroundColor: "#fff",
    borderRadius: "5px",
    display: "flex",
    gap: "10px",
    transition: "all 0.3s ease-in-out",
    overflow: "hidden",
    alignItems: "center",
  },
  notificationLevel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
    minWidth: "36px",
  },
  notificationContent: {
    padding: "10px 0px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  notificationAction: {
    marginLeft: "auto",
    alignSelf: "flex-end",
  },
  closeContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignSelf: "flex-start",
    width: "36px",
  },
  closeIcon: {
    margin: "4px",
    cursor: "pointer",
    fill: "#b1bec7",
  },
};
